import React from 'react';

import {
  SendChatMessageModal,
  BaseWidget,
  ChatMessageList,
  PermissionWall
} from 'modules/layer01';

import { Button } from '@mui/material';
import { modalUtil } from 'iron-forge-react-modules';
import { PermissionName } from 'generated/graphql';
import * as dataService from './dataService';



export interface IProps {
  orderId?: string;
  storeId: string;
  returnAuthorizationId?: string;
}

export const FC: React.FC<IProps> = props => {
  if (props.orderId) {
    return (
      <OrderFC
        storeId={props.storeId}
        orderId={props.orderId} />
    );
  } else if (props.returnAuthorizationId) {
    return (
      <ReturnAuthorizationFC
        returnAuthorizationId={props.returnAuthorizationId}
        storeId={props.storeId} />
    );
  }

  return null;
};



const OrderFC: React.FC<{
  orderId: string;
  storeId: string;
}> = props => {
  const tuple = dataService.useQuery(props.orderId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'addChatMessage'
  ]);

  function handleClickAddChatMessage() {
    setModalIsOpen('addChatMessage', true);
  }

  function handleCloseModal() {
    setModalIsOpen('addChatMessage', false);
  }

  return (
    <>
      <BaseFC
        storeId={props.storeId}
        requiredPermissions={['salesOrder_sendMessage']}
        chatMessages={tuple.data.chatMessages}
        onClickAddChatMessage={handleClickAddChatMessage} />

      {modalType2IsOpen['addChatMessage'] && (
        <SendChatMessageModal.FC
          orderId={props.orderId}
          onClose={handleCloseModal} />
      )}
    </>
  );
};



const ReturnAuthorizationFC: React.FC<{
  storeId: string;
  returnAuthorizationId: string;
}> = props => {
  const tuple = dataService.useReturnAuthorizationQuery(props.returnAuthorizationId);
  const {
    modalType2IsOpen,
    setModalIsOpen
  } = modalUtil.useModalTrackers([
    'addChatMessage'
  ]);

  function handleClickAddChatMessage() {
    setModalIsOpen('addChatMessage', true);
  }

  function handleCloseModal() {
    setModalIsOpen('addChatMessage', false);
  }



  return (
    <>
      <BaseFC
        storeId={props.storeId}
        requiredPermissions={['returnAuthorization_sendMessage']}
        chatMessages={tuple.data.chatMessages}
        onClickAddChatMessage={handleClickAddChatMessage} />

      {modalType2IsOpen['addChatMessage'] && (
        <SendChatMessageModal.FC
          returnAuthorizationId={props.returnAuthorizationId}
          onClose={handleCloseModal} />
      )}
    </>
  );
};



const BaseFC: React.FC<{
  storeId: string;
  requiredPermissions: PermissionName[];
  chatMessages: ChatMessageList.IMessage[];
  onClickAddChatMessage: () => void;
}> = props => (
  <BaseWidget.FC
    title="Messages"
    elAction={(
      <PermissionWall.FC
        storeId={props.storeId}
        requiresPermissions={props.requiredPermissions}>
        <Button
          variant="contained"
          onClick={props.onClickAddChatMessage}>
          Send message
        </Button>
      </PermissionWall.FC>
    )}>

    <ChatMessageList.FC messages={props.chatMessages} />
  </BaseWidget.FC>
);
